import './assets/css/index.css';
import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import * as GoogleAnalytics from './lib/google-analytics';
import Routes from './routes/Routes';
import { store, persistor } from './stores';

const { Kakao } = window;
if (!Kakao.isInitialized()) Kakao.init(process.env.REACT_APP_KAKAO_JAVASCRIPT_KEY);

GoogleAnalytics.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID);

const App = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Routes />
      </PersistGate>
    </Provider>
  );
}

export default App;
